module.exports = __webpack_public_path__ + "static/media/14.92f23505.png";